<div cdkTrapFocus class="modal-body country-switch text-center my-6 mx-5">
  <div class="container col-12">
    <div class="mb-5">
      <img [alt]="'countrySelector.countrySwitchModal.warning' | cxTranslate"
           class="warning-icon"
           src="assets/images/alert-r-orange.png">
    </div>
    <h3 class="mb-4">
      {{'countrySelector.countrySwitchModal.solutionNotAvailable' | cxTranslate}} {{requestedCountry}}
    </h3>
    <p class="mb-5">
      {{'countrySelector.countrySwitchModal.redirectToHomepage' | cxTranslate}}
    </p>
    <div class="actions row">
      <div class="col-12 col-lg-6">
        <button (click)="modal.close('confirmAndVisitHomepage')"
                class="btn btn-primary mb-4 float-lg-end"
                data-cy="confirmAndVisitHomepage">
          {{'countrySelector.countrySwitchModal.confirmAndVisitHomepage' | cxTranslate}}
        </button>
      </div>
      <div class="col-12 col-lg-6">
        <button (click)="modal.close('withdrawCountrySelection')"
                class="btn btn-outline-primary float-lg-start"
                data-cy="withdrawCountrySelection">
          {{'countrySelector.countrySwitchModal.withdrawCountrySelection' | cxTranslate}}
        </button>
      </div>
    </div>
  </div>
</div>

